import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-my-gray border-round-md min-h-full flex flex-column justify-content-between p-1 fadeinright" }
const _hoisted_2 = {
  key: 0,
  id: "chatScrollElement",
  class: "flex flex-column-reverse section-height p-1 overflow-y-scroll"
}
const _hoisted_3 = {
  key: 0,
  class: "text-center fadein animation-duration-1000 animation-iteration-infinite"
}

import { storeToRefs } from 'pinia';
import { computed, onMounted } from 'vue';
import { useAuthStore, useMessageCenterStore } from '@/store';
import Message from './components/Message.vue';
import InputMessage from './components/InputMessage.vue';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'Chat',
  setup(__props) {

const messageCenter = useMessageCenterStore();
const { sortedMessages, loading } = storeToRefs(messageCenter);
const authStore = useAuthStore();
const { user } = storeToRefs(authStore);
const { error } = storeToRefs(messageCenter);

const hasError = computed(() => !!error.value);

onMounted(() => init());

const init = () => {
  listenScroll();
};

const onLoadMoreMessages = async () => {
  messageCenter.getMoreMessages();
};

const listenScroll = () => {
  const scrollElement = document.getElementById('chatScrollElement');

  if (!scrollElement) {
    return setTimeout(listenScroll, 1000);
  }

  scrollElement.addEventListener('scroll', async () => {
    if (-scrollElement.scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight) {
      await onLoadMoreMessages();
    }
  });
};

const removeError = () => {
  messageCenter.error = undefined;
};

const onSentNewMessage = async (message: FormData) => {
  await messageCenter.sendMessage(message);

  if (hasError.value) {
    const message = error.value.data.errors
      ? Object.values(error.value.data.errors).flat().join(', ')
      : error.value.data.message;

    messageCenter.doToast(message, 'Error', true, 5000);
    removeError();
  }
};

const isYou = (sender: { id: number }) => {
  return sender.id === user?.value?.id;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(can)([_unref(PERMISSIONS).MESSAGE_INDEX]))
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedMessages), (message, index) => {
            return (_openBlock(), _createBlock(Message, {
              key: index,
              "created-at": message.created_at,
              "message-id": message.id,
              content: message.content,
              attachments: message.attachments,
              "display-name": message.sender.display_name,
              "is-you": isYou(message.sender)
            }, null, 8, ["created-at", "message-id", "content", "attachments", "display-name", "is-you"]))
          }), 128)),
          (_unref(loading))
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "..."))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(can)([_unref(PERMISSIONS).MESSAGE_STORE]))
      ? (_openBlock(), _createBlock(InputMessage, {
          key: 1,
          onMessageSent: onSentNewMessage
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})